export interface ZipCodeEntry {
  id: string;
  postalCode: string;
  city: string;
  district: string;
  canton: string;
}

export interface DistrictOption {
  id: string;
  label: string;
  canton: string;
  postcodes: string[];
  entries: ZipCodeEntry[];
}

export interface SelectedDistrictOption extends DistrictOption {
  isPartiallyCovered: boolean;
  selectedPostalCodeIds: string[];
  selectedPostalCodes: string[];
}

export enum CatalogLoadStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
